import { detectionIsOn, shouldRenderDetectionStatusChange } from '.';

/**
 * @returns true if detection is enabled for the given status change
 */
export const detectionIsOnForStatusChange = (
    statusChange: ManageDetectionsStatusChange,
): boolean =>
    shouldRenderDetectionStatusChange(statusChange) &&
    detectionIsOn(statusChange.status);
